module.exports = __webpack_public_path__ + "media/site_templates/www.carpetcleaning.agency/images/our_services_3-3966d616c4a583e04ef16ee5b0d1d973.jpg";